import { useAuth } from '@clerk/nextjs';
import { AuthenticatedApiClient } from '@web-app/utils/api-client';
import { useMemo } from 'react';

/**
 * React hook that provides an authenticated API client
 * Automatically handles token management and refresh using Clerk
 */
export const useApiClient = () => {
  const { getToken } = useAuth();

  return useMemo(() => {
    return new AuthenticatedApiClient({ getToken });
  }, [getToken]);
};
